import { Components, Theme } from '@mui/material/styles';

export const muiFormHelperTextOverride: Components<Theme>['MuiFormHelperText'] = {
  styleOverrides: {
    root: ({ theme }) => ({
      margin: 0,
      color: theme.vars.palette.text.secondary,
      '&.Mui-typography': {
        fontWeight: 400,
        fontSize: 10,
        [theme.breakpoints.up('md')]: {
          fontSize: 12,
        },
      },
    }),
  },
};
